import { render, staticRenderFns } from "./TotalAmountAdjustmentView.vue?vue&type=template&id=3b222be7&scoped=true"
import script from "./TotalAmountAdjustmentView.vue?vue&type=script&lang=js"
export * from "./TotalAmountAdjustmentView.vue?vue&type=script&lang=js"
import style0 from "./TotalAmountAdjustmentView.vue?vue&type=style&index=0&id=3b222be7&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b222be7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b222be7')) {
      api.createRecord('3b222be7', component.options)
    } else {
      api.reload('3b222be7', component.options)
    }
    module.hot.accept("./TotalAmountAdjustmentView.vue?vue&type=template&id=3b222be7&scoped=true", function () {
      api.rerender('3b222be7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/billingHistory/components/TotalAmountAdjustmentView.vue"
export default component.exports